export function formatSmartChartYesNo(value) {
  return value ? "yes" : "no";
}

export const CHART_COLUMN_TAB = {
  CHART_HISTORY: "chart-history",
  TEMPLATES: "templates",
  ADDITIONAL_CONTEXT: "additional-context",
  CUSTOM_PROMPT: "custom-prompt",
};

export function getChartColumnTabs(smartChart) {
  const tabs = [
    { id: CHART_COLUMN_TAB.CHART_HISTORY, label: "Chart history" },
    { id: CHART_COLUMN_TAB.TEMPLATES, label: "Templates" },
  ];

  if (smartChart?.has_additional_context && smartChart.starting_note) {
    tabs.push({
      id: CHART_COLUMN_TAB.ADDITIONAL_CONTEXT,
      label: "Additional context",
    });
  }

  if (smartChart?.has_custom_prompt && smartChart.custom_prompt) {
    tabs.push({
      id: CHART_COLUMN_TAB.CUSTOM_PROMPT,
      label: "Custom prompt",
    });
  }

  return tabs;
}
